import React, { memo, useCallback, useEffect } from 'react';

import { App, Button } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import TopPage from 'v2/components/Shared/TopPage';
import whitelistService from 'v2/services/whitelist';

import { Icon } from '@eduzz/ui-antd-theme';

import CreateAndEdit from './CreateAndEdit';
import Filter from './Filter';
import List from './List';

const WhiteList = () => {
  const { message } = App.useApp();

  useEffect(() => {
    whitelistService.loadWhiteLists().subscribe(
      () => {},
      () => message.error('Não foi possível carregar a whitelist.')
    );
  }, [message]);

  const newWhiteList = useCallback(() => {
    whitelistService.setCurrentWhiteList(null);
    whitelistService.setCreateAndEditDialog(true);
  }, []);

  useEffect(() => {
    return () => whitelistService.cleanFilter();
  }, []);

  return (
    <>
      <TopPage
        title='Recompra (Whitelist)'
        extra='Gerencie clientes que podem comprar várias vezes com o mesmo CPF/CNPJ.'
        disableAlerts
        action={
          <PermissionHide action='myeduzz:whitelist:editar'>
            <Button type='primary' icon={<Icon.Plus />} onClick={newWhiteList}>
              Adicionar cliente
            </Button>
          </PermissionHide>
        }
      />
      <CreateAndEdit />
      <Filter />
      <List />
    </>
  );
};

export default memo(WhiteList);
